/**
 * QueryPerformanceLogService
 * Service for database query performance logging
 * Route: api/queryperformancelog
 */
import { BaseService } from '../base/BaseService';
export class QueryPerformanceLogService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? QueryPerformanceLogService.DEFAULT_SERVICE_PATH,
            basePath: QueryPerformanceLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getQueryPerformanceLogs(params) {
        const endpoint = this.getEndpoint('', '');
        const queryParams = {};
        if (params?.serviceName)
            queryParams.serviceName = params.serviceName;
        if (params?.queryType)
            queryParams.queryType = params.queryType;
        if (params?.entityType)
            queryParams.entityType = params.entityType;
        if (params?.isSlowQuery !== undefined)
            queryParams.isSlowQuery = params.isSlowQuery.toString();
        if (params?.startDate)
            queryParams.startDate = params.startDate.toISOString();
        if (params?.endDate)
            queryParams.endDate = params.endDate.toISOString();
        if (params?.skip !== undefined)
            queryParams.skip = params.skip.toString();
        if (params?.take !== undefined)
            queryParams.take = params.take.toString();
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getQueryPerformanceLog(id) {
        const endpoint = this.getEndpoint('by-id', `${id}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? null;
    }
    async getRecentQueries(count = 50, serviceName) {
        const endpoint = this.getEndpoint('recent', 'recent');
        const queryParams = { count: count.toString() };
        if (serviceName)
            queryParams.serviceName = serviceName;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getSlowQueries(count = 100, serviceName, entityType) {
        const endpoint = this.getEndpoint('slow', 'slow');
        const queryParams = { count: count.toString() };
        if (serviceName)
            queryParams.serviceName = serviceName;
        if (entityType)
            queryParams.entityType = entityType;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getQueryPerformanceSummary(params) {
        const endpoint = this.getEndpoint('summary', 'summary');
        const queryParams = {};
        if (params?.serviceName)
            queryParams.serviceName = params.serviceName;
        if (params?.startDate)
            queryParams.startDate = params.startDate.toISOString();
        if (params?.endDate)
            queryParams.endDate = params.endDate.toISOString();
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? null;
    }
    async getQueriesByCorrelation(correlationId) {
        const endpoint = this.getEndpoint('by-correlation', `by-correlation/${correlationId}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getStatsByEntity(serviceName, take = 50) {
        const endpoint = this.getEndpoint('by-entity', 'by-entity');
        const queryParams = { take: take.toString() };
        if (serviceName)
            queryParams.serviceName = serviceName;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getStatsByQueryType(serviceName) {
        const endpoint = this.getEndpoint('by-type', 'by-type');
        const queryParams = {};
        if (serviceName)
            queryParams.serviceName = serviceName;
        const url = this.buildUrlWithParams(endpoint, queryParams);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
}
QueryPerformanceLogService.DEFAULT_SERVICE_PATH = 'system';
QueryPerformanceLogService.BASE_PATH = 'api/queryperformancelog';
//# sourceMappingURL=QueryPerformanceLogService.js.map